import React, { useContext } from "react";
import PropTypes from "prop-types";

// ------------------------------------------------------------

import { Flex, Box, Text } from "rebass";
import styled, { ThemeContext, createGlobalStyle } from "styled-components";

// ------------------------------------------------------------

import Popup from "components/PortalModal/popup";
import { PORTAL_IMAGE } from "constants/imagePath";
import { StyledButtonCross } from "components/PortalModal/styled";

// ------------------------------------------------------------

const StyledText = styled(Text)`
    color: ${props => props.theme.colours.blackTints700.hex};
`;

const HideScrollbarElement = createGlobalStyle`
   ::-webkit-scrollbar {
        width: 0px;
        background: transparent;
    }

    @media print{@page {size: landscape}}
`;

const CustomBox = styled(Box)`
    overflow-y: auto;
    & > * + * {
        margin-top: 16px;
    }
`;

// ------------------------------------------------------------

const HealthInfoPopup = ({ closeModal, modalIsOpen }) => {
    const theme = useContext(ThemeContext);
    return (
        <>
            <HideScrollbarElement />
            <Popup closeModal={closeModal} modalIsOpen={modalIsOpen} hideHeader>
                <Box data-testid="range-popup">
                    <Flex width="100%" justifyContent="space-between" mb="20px">
                        <Text color={theme.colours.hpPrimaryPurple.hex} fontSize={["22px", "28px"]}>
                            What specific health information will I need?
                        </Text>
                        <StyledButtonCross
                            onClick={closeModal}
                            src={`${PORTAL_IMAGE}/menu-close.svg`}
                            alt={"cross"}
                            data-testid="close-modal"
                        />
                    </Flex>
                    <CustomBox height={["100%", "150px"]}>
                        <StyledText
                            minWidth={["70px", "85px"]}
                            fontWeight={["normal", "300"]}
                            fontSize={["13px", "18px"]}
                        >
                            Information like your glucose levels, cholesterol levels and waist size measurements will
                            help us get a better idea of your possible health risks.
                        </StyledText>
                        <StyledText
                            minWidth={["70px", "85px"]}
                            fontWeight={["normal", "300"]}
                            fontSize={["13px", "18px"]}
                        >
                            If you don’t have access to those details right away, we’ll either provide you with an
                            estimate or allow you to skip the question.
                        </StyledText>
                    </CustomBox>
                </Box>
            </Popup>
        </>
    );
};

HealthInfoPopup.propTypes = {
    modalIsOpen: PropTypes.bool,
    closeModal: PropTypes.func
};

export default HealthInfoPopup;
